import { render, staticRenderFns } from "./WeflowLayout.vue?vue&type=template&id=16a4445b"
import script from "./WeflowLayout.vue?vue&type=script&lang=js"
export * from "./WeflowLayout.vue?vue&type=script&lang=js"
import style0 from "./WeflowLayout.vue?vue&type=style&index=0&id=16a4445b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports